<template>
  <div class="container">
    <!-- 页面内容 -->
    <!-- 新增标题 -->
    <h1 class="title">
      <i class="el-icon-data-analysis" /> 省单一窗口覆盖率看板
      <!-- 修改为纯图标 -->
      <i
        class="el-icon-back back-btn"
        @click="goBack"
      />
    </h1>

    <!-- 月份选择器和查询按钮 -->
    <div class="filter-container">
      <div class="date-pickers-wrapper">
        <el-date-picker
          v-model="startMonth"
          class="date-picker"
          size="mini"
          type="month"
          placeholder="开始月份"
          prefix-icon="el-icon-date"
        />
        <span class="date-separator">-</span>
        <el-date-picker
          v-model="endMonth"
          class="date-picker"
          size="mini"
          type="month"
          placeholder="结束月份"
          prefix-icon="el-icon-date"
        />
      </div>
      <!-- 快捷选择按钮和查询按钮 -->
      <div class="button-row">
        <el-button size="mini" @click="selectThisMonth">本月</el-button>
        <el-button size="mini" @click="selectLastMonth">上月</el-button>
        <el-button size="mini" @click="selectThisYear">今年</el-button>
        <el-button
          size="mini"
          type="primary"
          class="query-btn-large"
          :loading="loading"
          @click="queryData"
        >
          <i class="el-icon-search" /> 查询
        </el-button>
      </div>
    </div>
    <!-- 数据显示框 -->
    <div class="data-display">
      <div class="data-item">
        <div class="label"><i class="el-icon-tickets" /> 落地票数</div>
        <div class="value">{{ formatNumber(customsLocalCount) }}</div>
      </div>
      <div class="data-item">
        <div class="label"><i class="el-icon-document" /> 报关单总数</div>
        <div
          class="value"
          style="color: #ee6666"
        >{{ formatNumber(customsTotalCount) }}</div>
      </div>
      <div class="data-item">
        <div class="label"><i class="el-icon-pie-chart" /> 票数占比</div>
        <div
          class="value"
          style="color:#fac858;"
        >{{ formatPercent(countPercentage) }}</div>
      </div>
      <div class="data-item">
        <div class="label"><i class="el-icon-money" /> 落地金额(万元)</div>
        <div class="value">{{ formatNumber(customsLocalAmount) }}</div>
      </div>
      <div class="data-item">
        <div class="label"><i class="el-icon-wallet" /> 报关总金额(万元)</div>
        <div
          class="value"
          style="color: #ee6666"
        >{{ formatNumber(customsTotalAmount) }}</div>
      </div>
      <div class="data-item">
        <div class="label"><i class="el-icon-data-line" /> 金额占比</div>
        <div
          class="value"
          style="color:#fac858;"
        >{{ formatPercent(amountPercentage) }}</div>
      </div>
    </div>
    <!-- 图表区域 -->
    <div class="chart-wrapper">
      <div class="chart-header">
        <i class="el-icon-pie-chart" /> 福州海关各关区票数占比
      </div>
      <div
        id="customsChart"
        class="customs-chart"
      />
    </div>
  </div>
</template>

<script>
import { queryTotalCustomsDeclaration, codeFlag } from '@/api/app'
// 引入echarts
import * as echarts from 'echarts'

export default {
  inject: {
    getAuthCode: {
      default: () => null // 提供默认值，避免注入失败时出错
    }
  },
  data() {
    return {
      // 添加饼图相关数据
      customsChart: null,
      customsChartData: [
        { value: 1048, name: '关区1' },
        { value: 735, name: '关区2' },
        { value: 580, name: '关区3' },
        { value: 484, name: '关区4' },
        { value: 300, name: '关区5' }
      ],

      startMonth: null,
      endMonth: null,
      loading: false,
      code: '', // 添加code到data中
      customsTotalCount: 0,
      customsLocalCount: 0,
      countPercentage: 0,
      amountPercentage: 0,
      customsLocalAmount: null,
      customsTotalAmount: null,
      tableHeaderStyle: {
        background: '#f5f7fa',
        color: '#606266',
        fontWeight: '500',
        padding: '8px 0'
      }
    }
  },
  created() {
    // 获取授权码
    this.code = localStorage.getItem('authCode')
    // 在created生命周期中检查是否有code
    if (!this.code) {
      this.$message.warning('缺少必要参数，即将返回上级页面')
      // 延迟跳转，让用户看到提示信息
      setTimeout(() => {
        this.$router.push({
          path: 'dzka'
        })
      }, 1500)
      return
    }
    codeFlag(this.code).then(res => {
      if (!res.data) {
        this.$message.warning('验证码过期')
        localStorage.removeItem('authCode')
        // 延迟跳转，让用户看到提示信息
        setTimeout(() => {
          this.$router.push({
            path: 'dzka'
          })
        }, 1500)
        return
      }
    })
  },
  mounted() {
    // 只有在有code的情况下才初始化数据
    if (this.code) {
      this.initData()
    }
  },
  beforeDestroy() {
    // 移除窗口大小变化的事件监听
    window.removeEventListener('resize', this.resizeCustomsChart)
    // 销毁图表实例
    if (this.customsChart) {
      this.customsChart.dispose()
      this.customsChart = null
    }
  },
  methods: {
    // 添加返回上级方法
    goBack() {
      this.$router.push({
        path: 'dzka'
      })
    },
    queryData() {
      // 显示加载状态
      this.loading = true
      // 格式化日期
      const startTime = this.formatDateToString(this.startMonth)
      const endTime = this.formatDateToString2(this.endMonth)
      // 调用查询总报关单数据接口
      queryTotalCustomsDeclaration({
        startTime,
        endTime,
        code: this.code
      }).then(res => {
        this.customsLocalAmount = 0
        this.customsTotalAmount = 0
        this.customsLocalCount = 0
        this.customsTotalCount = 0
        this.customsChartData = [{ value: null, name: null }]
        this.updateCustomsChart()
        if (res.data && res.success) {
          // 重置数据
          this.customsLocalAmount = 0
          this.customsTotalAmount = 0
          this.customsLocalCount = 0
          this.customsTotalCount = 0

          // 只统计福州海关的数据用于上方显示
          res.data.forEach(val => {
            if (val.customsArea === '福州海关') {
              this.customsLocalAmount += val.localAmount
              this.customsTotalAmount += val.totalAmount
              this.customsLocalCount += val.localCount
              this.customsTotalCount += val.totalCount
            }
          })

          // 处理返回的数据
          this.countPercentage = this.customsTotalCount ? (this.customsLocalCount * 100 / this.customsTotalCount) : 0
          this.amountPercentage = this.customsTotalAmount ? (this.customsLocalAmount * 100 / this.customsTotalAmount) : 0

          // 更新饼图数据（从接口返回的数据中提取关区数据）
          // 将接口返回的数据转换为饼图所需的格式
          if (res.data && res.data.length > 0) {
            // 创建一个对象用于合并同名关区的数据
            const customsAreaMap = {}

            // 遍历数据，合并同名关区的数据，排除福州海关
            res.data.forEach(item => {
              const areaName = item.customsArea || '未知关区'
              // 过滤掉"福州海关"
              if (areaName !== '福州海关') {
                if (!customsAreaMap[areaName]) {
                  customsAreaMap[areaName] = 0
                }
                customsAreaMap[areaName] += (item.localCount || 0)
              }
            })

            // 将合并后的数据转换为饼图所需的格式并按数值排序
            const chartData = Object.keys(customsAreaMap).map(name => {
              return {
                value: customsAreaMap[name],
                name: name
              }
            }).sort((a, b) => b.value - a.value)

            // 只显示前5大关区，其余合并为"其他关区"
            let finalChartData = []
            if (chartData.length > 5) {
              // 取前5个关区
              finalChartData = chartData.slice(0, 5)
              // 计算其他关区的总和
              const otherValue = chartData.slice(5).reduce((sum, item) => sum + item.value, 0)
              if (otherValue > 0) {
                finalChartData.push({ value: otherValue, name: '其他关区' })
              }
            } else {
              finalChartData = chartData
            }

            // 更新饼图数据
            this.customsChartData = finalChartData.length > 0 ? finalChartData : [{ value: 0, name: '暂无数据' }]
            this.updateCustomsChart()
          } else {
            // 没有数据时显示暂无数据
            this.customsChartData = [{ value: 0, name: '暂无数据' }]
            this.updateCustomsChart()
          }
        } else {
          // 接口返回失败时重置所有数据
          this.customsLocalAmount = 0
          this.customsTotalAmount = 0
          this.customsLocalCount = 0
          this.customsTotalCount = 0
          this.countPercentage = 0
          this.amountPercentage = 0
          this.customsChartData = [{ value: 0, name: '暂无数据' }]
          this.updateCustomsChart()
        }
      }).catch(err => {
        console.error('查询总报关单数据失败:', err)
        this.$message.error('查询总报关单数据失败')
      }).finally(() => {
        // 关闭加载状态
        this.loading = false
      })
    },
    // 添加日期格式化方法
    formatDateToString(date) {
      if (!date) return ''
      const year = date.getFullYear()
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      return `${year}-${month}` + '-01 00:00:00'
    },
    // 添加日期格式化方法
    formatDateToString2(date) {
      if (!date) return ''
      const year = date.getFullYear()
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      return `${year}-${month}` + '-28 00:00:00'
    },
    // 格式化数字，添加千位分隔符
    formatNumber(num) {
      if (num === null || num === undefined) return '0'
      // 判断是否为小数
      if (Number(num) % 1 !== 0) {
        // 小数保留两位，不添加千分符
        return (Number(num).toFixed(2)).toString()
      }
      // 整数添加千分符
      return num.toString()
    },
    // 格式化百分比，保留2位小数
    formatPercent(num) {
      if (num === null || num === undefined) return '0.0%'
      return num.toFixed(2) + '%'
    },
    // 初始化数据
    initData() {
      // 设置默认日期范围
      const now = new Date()
      now.setMonth(now.getMonth() - 1)
      this.endMonth = now
      const startDate = new Date()
      startDate.setMonth(now.getMonth() - 1)
      this.startMonth = startDate
      // 初始化查询
      this.queryData()
      // 初始化图表
      this.$nextTick(() => {
        this.initCustomsChart()
      })
    },

    // 初始化关区饼图
    initCustomsChart() {
      // 确保DOM元素已经渲染
      if (!document.getElementById('customsChart')) return

      // 初始化图表实例
      if (this.customsChart) {
        this.customsChart.dispose()
      }
      this.customsChart = echarts.init(document.getElementById('customsChart'))

      // 设置图表选项
      const option = {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        grid: {
          top: 60, // 为顶部图例留出足够空间
          bottom: 10,
          containLabel: true
        },
        legend: {
          orient: 'horizontal',
          top: 10,
          left: 'center',
          itemWidth: 25,
          itemHeight: 14,
          textStyle: {
            fontSize: 12
          },
          data: this.customsChartData.map(item => item.name)
        },
        series: [
          {
            name: '关区票数',
            type: 'pie',
            radius: '50%',
            center: ['50%', '55%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
                  show: true,
                  position: 'outside',
                  formatter: '{b} {d}%',
                  fontSize: 11,
                  color: '#333',
                  distanceToLabelLine: 5
                },
            labelLine: {
                  show: true,
                  length: 15,
                  length2: 10,
                  lineStyle: {
                    color: '#999',
                    width: 1
                  }
                },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            data: this.customsChartData
          }
        ]
      }

      // 渲染图表
      this.customsChart.setOption(option)

      // 添加窗口大小变化时重绘图表
      window.addEventListener('resize', this.resizeCustomsChart)
    },

    // 重绘图表
    resizeCustomsChart() {
      if (this.customsChart) {
        this.customsChart.resize()
      }
    },
    // 更新关区饼图
    updateCustomsChart() {
      if (this.customsChart) {
        // 完全重新设置选项，而不是部分更新
        const option = {
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b}: {c} ({d}%)',
            backgroundColor: 'rgba(255,255,255,0.9)',
            borderColor: '#eee',
            borderWidth: 1,
            textStyle: {
              color: '#333'
            },
            extraCssText: 'box-shadow: 0 2px 8px rgba(0,0,0,0.1);'
          },
          grid: {
            top: 60, // 为顶部图例留出足够空间
            bottom: 10,
            containLabel: true
          },
          legend: {
            orient: 'horizontal',
            top: 10,
            left: 'center',
            itemWidth: 14,
            itemHeight: 14,
            itemGap: 15,
            textStyle: {
              fontSize: 12,
              color: '#333'
            },
            data: this.customsChartData.map(item => item.name)
          },
          color: [
            '#E53E3E', // 海港海关 - 红色
            '#2D3748', // 东渡海关 - 深灰色
            '#38B2AC', // 邮局海关 - 青绿色
            '#DD6B20', // 机场海关 - 橙色
            '#68D391', // 泉州海关 - 浅绿色
            '#805AD5', // 翔安海关 - 紫色
            '#F6AD55', // 其他 - 浅橙色
            '#A0AEC0'  // 集同海关 - 浅灰色
          ],
          series: [
            {
              name: '关区票数',
              type: 'pie',
              radius: '50%',
              center: ['51%', '55%'],
              avoidLabelOverlap: false,
              itemStyle: {
                borderColor: '#fff',
                borderWidth: 2
              },
              label: {
                show: true,
                position: 'outside',
                formatter: '{b} {d}%',
                fontSize: 11,
                color: '#333',
                distanceToLabelLine: 5
              },
              labelLine: {
                show: true,
                length: 15,
                length2: 10,
                lineStyle: {
                  color: '#999',
                  width: 1
                }
              },
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              },
              data: this.customsChartData
            }
          ]
        };
        this.customsChart.setOption(option, true)

        // 确保图表容器有足够的高度显示图例
        setTimeout(() => {
          this.customsChart.resize()
        }, 100)
      } else {
        this.initCustomsChart()
      }
    },
    // 快捷选择本月
    selectThisMonth() {
      const now = new Date()
      const thisMonth = new Date(now.getFullYear(), now.getMonth(), 1)
      this.startMonth = thisMonth
      this.endMonth = thisMonth
      this.queryData() 
    },
    // 快捷选择上月
    selectLastMonth() {
      const now = new Date()
      const lastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1)
      this.startMonth = lastMonth
      this.endMonth = lastMonth
      this.queryData() 
    },
    // 快捷选择今年
    selectThisYear() {
      const now = new Date()
      const startOfYear = new Date(now.getFullYear(), 0, 1)
      const endOfYear = new Date(now.getFullYear(), 11, 1)
      this.startMonth = startOfYear
      this.endMonth = endOfYear
      this.queryData() 
    }
  }
}
</script>

<style scoped>
.container {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px;
  max-width: 1200px;
  margin: 0 auto;
  background-color: #f5f7fa;
  min-height: 100vh; /* 确保容器至少占满整个视口高度 */
  overflow: hidden;
  position: fixed; /* 添加固定定位 */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /* -webkit-overflow-scrolling: touch; */ /* 注释掉这个属性，它会启用滚动回弹效果 */
}

.filter-container {
  display: flex;
  flex-direction: column; /* 改为纵向排列 */
  background: white;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 10px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.1);
}

.date-pickers-wrapper {
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: 10px; /* 添加底部间距 */
}

.date-picker {
  flex: 1; /* 让日期选择器平均分配空间 */
  max-width: calc(50% - 10px); /* 确保两个选择器不会超出容器 */
}

.date-separator {
  margin: 0 5px;
  color: #909399;
  flex-shrink: 0; /* 防止分隔符被压缩 */
}

.button-row {
  display: flex;
  gap: 8px;
  justify-content: space-between;
}

.button-row .el-button {
  flex: 1;
  transition: all 0.3s;
}

.button-row .query-btn-large {
  flex: 2;
}

.button-row .el-button:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}

.title {
  color: #333;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
  padding: 10px 0;
  margin: 0 0 10px 0;
  border-bottom: 1px solid #dcdfe6;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  position: relative; /* 添加相对定位 */
}

/* 修改返回按钮为纯图标 */
.back-btn {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 20px;
  color: #409EFF;
  cursor: pointer;
  transition: all 0.3s;
}

.back-btn:hover {
  color: #66b1ff;
  transform: translateY(-50%) scale(1.1);
}

.title i {
  margin-right: 8px;
  color: #409EFF;
}

.data-display {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  margin: 0 0 10px 0;
  padding: 10px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.1);
}

.data-item {
  background: #f9f9f9;
  padding: 12px 8px;
  border-radius: 6px;
  text-align: center;
  transition: all 0.3s;
  border: 1px solid #ebeef5;
}

.data-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.label {
  color: #606266;
  font-size: 14px;
  margin-bottom: 8px;
}

.value {
  color: #409EFF;
  font-size: 18px;
  font-weight: bold;
}

/* 添加图表容器样式 */
.chart-wrapper {
  background: white;
  border-radius: 8px;
  padding: 10px;
  margin-bottom: 10px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.1);
  overflow: hidden;
}

.chart-header {
  font-size: 16px;
  font-weight: 500;
  color: #303133;
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 1px solid #ebeef5;
}

.customs-chart {
  width: 100%;
  height: 350px;
  background: #f8f9fa;
  border-radius: 8px;
  padding: 10px;
}

/* 优化移动端布局 */
@media (max-width: 768px) {
  .container {
    padding: 8px;
  }

  .title {
    font-size: 18px;
    padding: 8px 0;
  }

  .filter-container {
    padding: 10px;
  }

  .date-pickers-wrapper {
    flex-wrap: nowrap; /* 确保不换行 */
  }

  .date-picker {
    max-width: calc(50% - 10px);
  }

  .date-separator {
    width: 20px;
    text-align: center;
  }

  .data-display {
    grid-template-columns: repeat(3, 1fr);
    gap: 6px;
    padding: 6px;
  }

  .data-item {
    padding: 8px 4px;
  }

  .label {
    font-size: 12px;
    margin-bottom: 4px;
  }

  .value {
    font-size: 16px;
  }
}

/* 小屏幕手机适配 */
@media (max-width: 375px) {
  .data-item {
    padding: 6px 2px;
  }

  .label {
    font-size: 11px;
  }

  .value {
    font-size: 14px;
  }
}
</style>
